<template>
  <div class="d-flex-column justify-start align-start gap-18">
    <label class="t-white font-family-2 bold-xxl">{{
      $t("path_of_exile.what_you_get")
    }}</label>

    <!-- <p></p> -->
    <ul class="reward_list" :class="[currentGameSlug]">
      <li
        v-for="con in count"
        :key="con"
        class="regular-l t-grey font-family-2"
      >
        {{ $t(`${currentGameSlug}.${currentGamePackSlug}.rewards.${con}`) }}
      </li>
    </ul>
  </div>
</template>

<script setup>
const { currentGameSlug, currentGamePackSlug } = useGameComposable();
const props = defineProps({
  count: {
    default: 7,
  },
});
</script>

<style lang="scss">
// .reward_list {

// }
.reward_list {
  width: 100%;
  list-style-type: disc !important; // Ensure the bullets are visible
  padding: 0;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-left: 16px;
  margin-top: 6px;
  flex-wrap: wrap;
  gap: 5px;
  li::marker {
    color: #9a9a9a !important; // Set bullet color
  }
}
</style>
